import React from "react";
import Images from "../../Helpers/Images";
import { Form } from "react-bootstrap";
import ThemeButtom from "../../Components/ThemeButtom";

const ForgotPassword = () => {
  return (
    <div className="forgotPassword-wrapper">
      <div className="inner">
        <div className="left">
          <img src={Images.forgotPassword} alt="forgot-pass-img" />
        </div>
        <div className="right">
          <img src={Images.logo} alt="logo" />
          <div className="forgot-box">
            <h4>Forgot Password</h4>
            <p>Enter Your Email And We Will Help You reset Your Password.</p>
            <Form>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                {/* <Form.Label>Email</Form.Label> */}
                <Form.Control type="email" placeholder="Enter email" />
              </Form.Group>
              <ThemeButtom title="Submit"/>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
